import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import addChangeMessage from "../../../controllers/booking/postTicketing/change/addMessage";
import { Modal3 } from "../../DIsplay/Modal/Modal3";
import Button1 from "../../form/Button1";
import TextInput from "../../form/TextInput";
import moment from "moment";
import { getOrderManagementId } from "../../../utils/task/taskUtilFun";

function TaskRemarkModal({
  data,
  openUpdateChangeRequest,
  setOpenUpdateChangeRequest,
  setAffect,
}) {
  const [payload, setPayload] = useState({
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const orderManagementId = getOrderManagementId(data);

  async function handleSubmit(ev) {
    ev?.preventDefault();
    setLoading(true);
    const res = await addChangeMessage(orderManagementId, payload);
    setLoading(false);
    if (res?.return) {
      enqueueSnackbar(res.msg, { variant: "success" });
      setOpenUpdateChangeRequest(false);
      setPayload({ message: "" });
      setAffect((p) => p + 1);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  return (
    <Modal3
      open={openUpdateChangeRequest}
      setOpen={setOpenUpdateChangeRequest}
      title={"Add an update"}
    >
      <div className="card p-4 flex flex-col  gap-4 md:min-w-[500px]">
        <div className="flex flex-col gap-4">
          {/* <h5>What's missing?</h5> */}
          <div className="flex gap-2">
            <p>Re-issue Request Time: </p>
            <span>{moment(data?.updatedAt).format("YYYY-MM-DD, HH:mm")}</span>
          </div>
          <TextInput
            label="Remarks"
            multiline
            rows={5}
            // placeholder={'e.g. Phone number is required'}
            value={payload?.message || ""}
            onChange={(ev) =>
              setPayload({
                message: ev.target.value,
              })
            }
          />
          <div className="flex justify-end items-center gap-4">
            <div>
              <Button1
                variant="outlined"
                className="btn-outlined flex-1"
                onClick={() => setOpenUpdateChangeRequest(false)}
              >
                Cancel
              </Button1>
            </div>
            <Button1 onClick={(ev) => handleSubmit(ev)} loading={loading}>
              Add Update
            </Button1>
          </div>
        </div>
      </div>
    </Modal3>
  );
}

export default TaskRemarkModal;
